package com.bikompanion.data.cache

import kotlinx.serialization.Serializable

/** Which areas are stored and when each was written, so a sweep needs to decode nothing else. */
@Serializable
internal data class CachedParkingIndex(
    val areas: Map<String, Long> = emptyMap(),
)
